import AbstractService from "../../vendors/services/abstractService";
import { urlApi } from "../shared/apis/api";

export default class EventoService extends AbstractService {
  constructor() {
    super(urlApi, "ManterEvento");
  }

  getAno() {
    return this.api.get(`${this.rota}/Ano`);
  }

  getTipoEvento(adm?: boolean) {
    const query = adm ? "?adm=true" : "";
    return this.api.get(`${this.rota}/TipoEvento${query}`);
  }

  getSituacao() {
    return this.api.get(`${this.rota}/Situacao`);
  }

  getSituacaoADM() {
    return this.api.get(`${this.rota}/SituacaoADM`);
  }

  getMeusEventos(filter: any) {
    const serialized = this.serialize(filter);
    return this.api.get(`${this.rota}/MeuEvento?${serialized}`);
  }

  getDashboard(codContribuinte: any) {
    return this.api.get(
      `${this.rota}/Dashboard?codigoContribuinte=${codContribuinte}`
    );
  }

  getDispositivo(codDispositivo: any, codContribuinte: any) {
    return this.api.get(
      `${this.rota}/Dispositivo?codDispositivo=${codDispositivo}&codContribuinte=${codContribuinte}`
    );
  }

  getNormaDefinitiva(cdContribuicao: any) {
    return this.api.get(
      `${this.rota}/NormaDefinitiva?codigoAudienciaPublica=${cdContribuicao}`
    );
  }

  getDegravacao(cdContribuicao: any) {
    return this.api.get(
      `${this.rota}/Degravacao?codigoAudienciaPublica=${cdContribuicao}`
    );
  }

  getSessaoPresencial(cdContribuicao: any, codContribuinte: any) {
    return this.api.get(
      `${this.rota}/SessaoPresencial?codigoAudienciaPublica=${cdContribuicao}&codContribuinte=${codContribuinte}`
    );
  }

  getSessaoPresencialSemLogin(cdContribuicao: any) {
    return this.api.get(
      `${this.rota}/SessaoPresencialDeslogado?codigoAudienciaPublica=${cdContribuicao}`
    );
  }

  getRelatorio(cdContribuicao: any) {
    return this.api.get(`${this.rota}/Relatorio/${cdContribuicao}`);
  }

  getEvento(id: any, codContribuinte: any) {
    return this.api.get(
      `eventos/${id}`
    );
  }

  getAnexoProposta(cdContribuicao: any) {
    return this.api.get(
      `${this.rota}/Documentacao/AnexoProposta?CodProposta=${cdContribuicao}`
    );
  }


  getProposta(CodigoPropostaNorma: any) {
    return this.api.get(
      `${this.rota}/Proposta/DispositivoPorProposta?CodigoPropostaNorma=${CodigoPropostaNorma}&PageSize=1000`
    );
  }

  getPropostaID(id: any, codContribuinte: any) {
    return this.api.get(
      `eventos/${id}/propostas`
    );
  }

  compartilharEvento(obj: any) {
    return this.api.post(`${this.rota}/Compartilhar`, this.cleanObject(obj));
  }

  getCpfUsuarioInterno(login: any) {
    return this.api.get(`${this.rota}/BuscarMembroLogin?login=${login}`);
  }
  getMembroInterno(cpf: any) {
    return this.api.get(`${this.rota}/BuscarMembroCPF?cpf=${cpf}`);
  }
  canContribuite(codEvento: any, email: any, token: any) {
    return this.api.get(
      `/contribuicoes/pode-contribuir?CodAudienciaPublica=${codEvento}&email=${email}&token=${token}`
    );
  }
}
